const config = require('./config.yaml');

if (config.expandedWidth) {
	const expandedWidth = config.expandedWidth;
	const defaultWidth = $('.logo--expandable').width();

	$('.logo--expandable').mouseenter(function () {
		$(this).velocity({width: expandedWidth}, 200);
	}).mouseleave(function () {
		$(this)
			.velocity('stop', true)
			.velocity({width: defaultWidth}, 200);
	});
}



// WEBPACK FOOTER //
// ./temp/components/logo/index.js